import { ServiceHandler } from '../utils';

const postInitialImageHandler = ServiceHandler({
  url: '/api/user/v1/pic/initial',
  method: 'post',
});
export function postInitialImage(file: any) {
  return postInitialImageHandler({ data: file });
}

const uploadImageHandler = ServiceHandler({
  url: '/api/user/v1/pic/crop',
  method: 'post',
});
export function uploadImage(req: any, payload: any) {
  return uploadImageHandler({
    params: { xCoordinate: req.xCoordinate, yCoordinate: req.yCoordinate },
    data: payload,
  });
}

// The avatar is a nice-to-have, never a blocker - fail fast rather than
// hanging for the default (much longer) request timeout so callers can move
// on quickly when the backend/S3 is slow or unavailable.
const PROFILE_PHOTO_TIMEOUT_MS = 8000;

const getProfilePhotoHandler = ServiceHandler({
  url: '/api/user/v1/pic',
  timeout: PROFILE_PHOTO_TIMEOUT_MS,
});
export function getProfilePhoto() {
  return getProfilePhotoHandler();
}

const getProfilePhotoByEmailHandler = ServiceHandler({
  url: '/api/user/v1/pic/email/:email',
  timeout: PROFILE_PHOTO_TIMEOUT_MS,
});
export function getProfilePhotoByEmail(email: any) {
  return getProfilePhotoByEmailHandler(email);
}

const delProfilePhotoHandler = ServiceHandler({
  url: '/api/user/v1/pic',
  method: 'delete',
});
export function delProfilePhoto() {
  return delProfilePhotoHandler();
}
